import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from '@/lib/auth/components/auth-provider'
import Unauthorized from '@/lib/auth/components/unauthorized'
import { ROLES } from '@/lib/auth/roles'
import { isCurrentPage, validateSearchWithDefaults } from '@/lib/utils'
import { reportQueryOptions, risksOrOpportunitiesQueryOptions } from '@/modules/client-actions-report/hooks/hooks'
import Opportunity from '@/modules/client-actions-report/opportunity'
import { ClientActionsReportType, ClientActionsTypes } from '@/types/enums/client-actions'
import {
  ClientActionsReportOpportunitySearch, defaultFetchParamsReport,
  defaultFetchParamsReportRisksOrOpportunities, mergedReportOpportunitySchema,
} from '@/types/route-search-schemas'
import { DataLoader } from '@/types/router-context'
import {OPPORTUNITY_REPORT_PATH, OPPORTUNITY_REPORT_URL} from '@/utils/urls'

export const Route = createFileRoute(OPPORTUNITY_REPORT_PATH)({
  component: OpportunityReport,
  validateSearch: (search: Record<string, unknown>): ClientActionsReportOpportunitySearch => {
    const tab = String(search.tab ?? 'report')
    return validateSearchWithDefaults(mergedReportOpportunitySchema, { tab, ...search })
  },
  loader: ({ context: { queryClient, date, roles } }: DataLoader) => {
    if (isCurrentPage(OPPORTUNITY_REPORT_URL)) {
      return
    }
    if (roles.includes(ROLES.ROLE_ELEVATION)) {
      queryClient.prefetchQuery(reportQueryOptions(date, defaultFetchParamsReport, ClientActionsReportType.OPPORTUNITY))
      queryClient.prefetchQuery(risksOrOpportunitiesQueryOptions(date, defaultFetchParamsReportRisksOrOpportunities, ClientActionsTypes.OPPORTUNITIES))
    }
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Client actions', path: '#' },
        { label: 'Opportunities', path: '/' }
      ],
    }
  },
})

function OpportunityReport() {
  return (
    <div className='flex flex-col items-center justify-center max-sm:p-5'>
      <Authorisation
        roles={[ROLES.ROLE_ELEVATION]}
        permissions={[]}
        forbiddenFallback={<Unauthorized />}
      >
        <Opportunity />
      </Authorisation>
    </div>
  )
}

